export const ancillaryTypes = {
  TRIP_FLEX: 'TRIP_FLEX',
  PRIORITY_BOARDING: 'PRIORITY_BOARDING',
  CHECK_IN_BAG: 'CHECK_IN_BAG',
  CARRY_ON_BAG: 'CARRY_ON_BAG',
  ONBOARD_ENTERTAINMENT: 'ONBOARD_ENTERTAINMENT',
};

export const ssrCodes = {
  LAP_INFANT: 'INFT',
  PET_IN_CABIN: 'PETC',
};

export const suffixLabels = {
  JR: 'Jr.',
  SR: 'Sr.',
  I: 'I',
  II: 'II',
  III: 'III',
};

export const tripflexCode = {
  TRIP_FLEX: "TP",
  ENHANCED_TRIP_FLEX: "TP2",
}
